import { A, N } from 'ts-toolbelt'
import { createHash } from 'node:crypto'

// this is the correct type, but the result gives a 'too complex to represent' error
// type Digit = N.Range<0, 9>[number]
// type MaybeDigit = Digit | ''
// type ConstructedPin = `${Digit}${Digit}${Digit}${Digit}${MaybeDigit}${MaybeDigit}${MaybeDigit}${MaybeDigit}`

export type Pin = A.Type<
    `${
        // this allows any string that can be coerced to a number(1.1, 0xa, etc), so also need to brand it
        number
    }` & { length: N.Range<4, 8>[number] },
    'pin'
>

export const isValidPin = (maybePin: string): maybePin is Pin =>
    /^\d{4,8}$/.test(maybePin)

// reference python implementation:
// def hashCommands(joinedCmds):
//     return hashlib.sha1(bytes(joinedCmds, 'ascii')).hexdigest()
export const hashCommands = (joinedCmds: string): string =>
    createHash('sha1').update(joinedCmds).digest('hex')

// reference python implementation:
// # Uses a Cipher-Block-Chaining (CBC) algorithm to encrypt the PIN.  Note the encrypted PIN has the same length as the PIN.
// # See https://en.wikipedia.org/wiki/Block_cipher_mode_of_operation#Cipher_Block_Chaining_(CBC) for more information.
// #------------------------------------------------------------------------------------------------------------------------------
// def encryptPin(cleartextPin):
//     initVector = 0x44
//     bytePin    = bytearray(cleartextPin, 'ascii')
//     for index in range(len(bytePin)):
//         initVector     ^= bytePin[index]
//         bytePin[index]  = initVector
//     return bytePin.decode('ascii')

export const encryptPin = (cleartextPin: Pin): string =>
    new TextEncoder().encode(cleartextPin).reduce(
        ({ initVector, result }, charCode) => {
            const newInitVector = initVector ^ charCode
            return {
                initVector: newInitVector,
                result: result + String.fromCharCode(newInitVector),
            }
        },
        { initVector: 0x44, result: '' }
    ).result
